const Kategoriya2311 = () => {
    return (
        <div style={{ fontFamily: "Times New Roman", fontSize: "14pt" }} className="container mt-5">
            <h3 className="text-center text-primary">
                2-sinf 3-chorak<br />
                Mavzu: Gap <br />
“Eng oson” bo‘limidagi topshiriqlar va ularni o‘tkazish metodikasi
            </h3>
            <b>1-mashq. Quyidagi so‘zlarga mos qo‘shimchalar qo‘shib, birikmalar hosil qiling.</b><br />
            <i>Ta’limiy maqsad:</i> O‘quvchilarning so‘z birikmalari haqidagi ko‘nikmalarini rivojlantirish. <br />
            <i>Mashg‘ulot davomiyligi:</i> 3-4 daqiqa.<br />
            <ul>
                <li>Do‘stim___ kitob__</li>
                <li>Osmon____ rang__</li>
                <li>Ukam___ qaradi__</li>
                <li>Mashina___ chiqdi__</li>
            </ul>
            <p><b>2-mashq. Juftlikda ishlang. Aralash berilgan so‘zlardan gaplar hosil qiling.</b></p>
            <p><i>Ta’limiy maqsad:</i> O‘quvchilarning gaplar ustida ishlash ko‘nikmalarini rivojlantirish.</p>
            <p><i>Mashg‘ulot davomiyligi:</i>3-4 daqiqa.</p>
            <p className="text-break">yursang, sayoq, yeysan, tayoq
_______________________________________________________________
</p>
            <p className="text-break">donosi, qahramoni, ertak, donolar
____________________________________________________________
</p>
            <p><b>3-mashq. Maqollarni davom ettiring, nuqtalar o‘rniga mos so‘zni qo‘ying.</b></p>
            <p><i>Ta’limiy maqsad:</i>O‘quvchilarning bog‘lanishli nutqini rivojlantirish ko‘nikmalarini rivojlantirish.</p>
            <p><i>Mashg‘ulot davomiyligi:</i>3-4 daqiqa.</p>
            <p>Kengashli _______  tarqamas.</p>
            <p>Vatan _____________ boshlanadi.</p>
        </div>
    )
}
export default Kategoriya2311;